import { FormHandles } from "@unform/core";

import { InputTypes } from "../UserData.screen";

import { reduceFormErrors } from "./signUp.reduceFormErrors";

interface SetLoadingInInputParams {
  formRef: React.RefObject<FormHandles>;
  inputName: InputTypes;
  type: "loading" | "success";
}

interface SetMessageErrorInInputParams {
  formRef: React.RefObject<FormHandles>;
  inputName: InputTypes;
  errorMessage: string;
}

export const setStatusInInput = ({
  formRef,
  inputName,
  type,
}: SetLoadingInInputParams): void => {
  try {
    formRef.current?.setErrors(
      reduceFormErrors(formRef, { [inputName]: type })
    );
  } catch (error) {
    console.log(setStatusInInput.name, error);
  }
};

export const setErrorInInput = ({
  formRef,
  inputName,
  errorMessage,
}: SetMessageErrorInInputParams): void => {
  try {
    formRef.current?.setErrors(
      reduceFormErrors(formRef, {
        [inputName]: errorMessage,
      })
    );
  } catch (error) {
    console.log(setErrorInInput.name, error);
  }
};
